import MapLegend from './MapLegend';
import MapLegendHeader from './MapLegendHeader';
import MapLegendItem from './MapLegendItem';
import MapLegendAccordion from './MapLegendAccordion';

export default MapLegend;
export * from './types';
export { MapLegend, MapLegendAccordion, MapLegendHeader, MapLegendItem };
